import MissouriHacks from '../images/mh-white.svg'
import Instagram from '../images/icon/instagram.svg';
import LinkedIn from '../images/icon/linkedin.svg';

export default function Footer() {
    return (
        <div id = "footer" style = {{backgroundColor: 'black', margin: '0', paddingTop: '40px'}}>
            <div id = "footer-links" style = {{display: 'flex', flexWrap: 'wrap', justifyContent: 'left', gap: '50px', marginLeft: '20px', marginRight: '20px', height: 'max-content'}}>
                <div className = "footer-column">
                    <img src = {MissouriHacks} style = {{marginTop: '20px', marginBottom: 'auto'}}></img>
                </div>
                <div className = "footer-column">
                    <p className = "footer-title">RESOURCES</p>
                    <a href = "https://missouri.qualtrics.com/jfe/form/SV_aW7iuYIZpNXiphQ" target='_blank'>Registration</a>
                    <a href = "https://docs.google.com/document/d/1A6j7v2GQD0cmVfwezUIOLXtFhDrfqZZ-eD41tEOx-Zc/edit?usp=sharing" target="_blank">Youth Protection Plan</a>
                </div>
                 <div className = "footer-column">
                    <p className = "footer-title">CONTACT</p>
                    <a href = "mailto:mizzoumca@gmail.com">mizzoumca@gmail.com</a>
                    <div style = {{display: 'flex'}}>
                        <a className = "social-media" href = "https://www.instagram.com/missourihacks/">
                            <img src = {Instagram} style = {{filter: 'invert(100%)'}}></img>
                        </a>
                        <a className = "social-media" href = "https://www.linkedin.com/company/missouri-hacks/">
                            <img src = {LinkedIn} style = {{filter: 'invert(100%)'}}></img>
                        </a>
                    </div>
                </div>
            </div>
            <p id = "creds" style = {{textAlign: 'center', marginBottom: '0px', paddingBottom: '10px', marginTop: '50px'}}>Designed & Programmed by <a href = "https://www.linkedin.com/in/derek-nissen/" style = {{transitionDuration: '.4s'}}>Derek Nissen</a></p>
        </div>
    )
}